<template>
  <div>
    <div v-if="question && myAnswer">
      <DialogYesNo
        :visible="visible"
        @hidden="hidden"
        title="Answer a question:"
        @ok="submitQuestion"
      >
        <b-alert show>{{ question.question }}</b-alert>
        <b-form-group
          v-if="question.type == 'any'"
          description="Write your answer here. Your team can answer only once."
          label="Your answer:"
        >
          <b-form-input v-model="myAnswer.answer" autofocus required />
        </b-form-group>
        <b-form-group
          v-if="question.type == 'number'"
          description="Write your answer here, it must be a number. Your team can answer only once."
          label="Your answer:"
        >
          <b-form-input
            type="number"
            v-model="myAnswer.answer"
            autofocus
            required
          />
        </b-form-group>
        <b-form-group
          v-if="question.type == 'round'"
          description="Choose your answer here. Your team can answer only once."
          label="Your answer:"
        >
          <b-form-select v-model="myAnswer.answer" autofocus required>
            <b-form-select-option v-if="allowRandomRound" :value="allRoundsJSON"
              >~ Random ~</b-form-select-option
            >
            <b-form-select-option
              v-for="r in rounds"
              :key="r.id"
              :value="r.name"
              >{{ r.name }}</b-form-select-option
            >
          </b-form-select>
        </b-form-group>

        <b-alert variant="warning" :show="hostMode">
          <b>Note:</b> You are answering for all teams that have not answered
          this question yet!
        </b-alert>
      </DialogYesNo>
      <DialogError v-model="errorVisible">{{ errorMessage }}</DialogError>
    </div>
  </div>
</template>

<script>
import DialogError from "@/components/DialogError";
import DialogYesNo from "@/components/DialogYesNo";
import { mapGetters } from "vuex";
export default {
  name: "SurveyAnswerDialog",
  components: { DialogYesNo, DialogError },
  props: {
    question: {
      default: null
    },
    visible: {
      default: false
    },
    rounds: {
      default() {
        return [];
      }
    },
    allowRandomRound: {
      default: false
    },
    hostMode: {
      default: false
    }
  },
  model: {
    prop: "visible",
    event: "updateVmodel"
  },
  watch: {
    question(newValue) {
      if (newValue) {
        this.myAnswer = this.emptyAnswer(newValue);
      }
    }
  },
  computed: {
    ...mapGetters("teamStore", { activeTeamID: "activeTeamID" }),
    allRoundsJSON() {
      var list = [];
      this.rounds.forEach(round => {
        list.push(round.name);
      });

      return list;
    }
  },
  data() {
    return {
      errorVisible: false,
      errorMessage: "",
      myAnswer: {}
    };
  },
  methods: {
    emptyAnswer(question) {
      var a = {};
      a.quiz_id = question.quiz_id;
      a.team_id = this.activeTeamID;
      a.question_id = question.id;
      a.answer = "";
      return a;
    },
    hidden() {
      this.$emit("updateVmodel", false);
    },
    submitQuestion(ev) {
      if (this.myAnswer.answer.length == 0) {
        ev.preventDefault();
        this.errorMessage = "You did not answer the question.";
        this.errorVisible = true;
        return;
      }

      this.$emit("answer-submit", this.myAnswer);
    }
  }
};
</script>
